import { GET_FILE_LIST, RESET_FILES } from '../types';

export default function (fileList = {}, action) {
  switch (action.type) {
    case GET_FILE_LIST:
      if (action.files.files.length === 0) return { id: action.files.id, downloads: [], media: []};
      return { id: action.files.id, ...extractMp3(action.files.files) };
    case RESET_FILES:
      return {};
    default:
      return fileList;
  }
}

function extractMp3(files) {
  const result = {
    downloads: [],
    media: []
  }
  files = addIds(files);
  files.forEach(file => {
    if (isMp3(file)) {
      result.media.push(file);
    } else {
      result.downloads.push({ ...file, type: getFileType(file)});
    }
  });
  return result;
}

function addIds(files) {
  return files.map(file => {
    return { ...file, id: getFileId(file)}
  });
}

function getFileId(file) {
  let url = file.url;
  const idx1 = url.indexOf('/');
  const idx2 = url.lastIndexOf('/');
  url = url.substr(idx1, idx2 - idx1);
  const idx3 = url.lastIndexOf('/');
  return parseInt(url.substr(idx3 + 1));
}

function isMp3(file) {
  return file.name.substr(-3) === 'mp3';
}

function getFileType(file) {
  return file.name.substr(file.name.lastIndexOf('.') + 1);
}